import React, { useCallback, useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import "chart.js/auto";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import CommonService from "../../services/common.service";

function ChallanGeneratedGraph({ depo }) {
  const [activeYearly, setActiveYearly] = useState(1);

  const location = useLocation();

  const [graphDataNew, setGraphDataNew] = useState([]);

  const fetchChallanCount = useCallback(() => {
    const payload = {
      locid:
        location.pathname.includes("/centralDashboard") ||
        location.pathname === "/"
          ? "0"
          : depo,
      type: activeYearly.toString(),
    };
    CommonService.getChallanCountNew(payload.locid, payload.type)
      .then((resp) => {
        console.log(resp.data);
        // const locactionWiseData = resp.data.reduce((acc, item) => {
        //   const existingDepo = acc.find(
        //     (depo) => depo.depoName === item.locname
        //   );
        //   if (existingDepo) {
        //     existingDepo.data.push(item);
        //   } else {
        //     acc.push({
        //       depoName: item.locname,
        //       data: [item],
        //     });
        //   }
        //   return acc;
        // }, []);
        setGraphDataNew(resp.data);
      })
      .catch((e) => console.log(e));
  }, [activeYearly, location.pathname]);

  useEffect(() => {
    fetchChallanCount();
  }, [fetchChallanCount]);

  // console.log(graphDataNew);

  const handleYearlyFilter = (from) => {
    setActiveYearly(from);
  };

  const generateLast7DaysData = () => {
    const data = [];
    for (let i = 0; i < 7; i++) {
      const date = dayjs().subtract(i, "day").format("DD/MM");
      data.push(date);
    }
    return data.reverse();
  };

  const generateLast7YearsData = () => {
    const currentYear = dayjs().year();
    return Array.from({ length: 7 }, (_, i) =>
      (currentYear - i).toString()
    ).reverse();
  };

  const months = Array.from({ length: dayjs().month() + 1 }, (_, i) =>
    dayjs().month(i).format("MMM")
  );

  const data =
    activeYearly === 1
      ? generateLast7DaysData()
      : activeYearly === 2
      ? months
      : activeYearly === 3
      ? generateLast7YearsData()
      : [];

  const colors = [
    "rgba(255, 232, 138, 1)",
    "rgba(88, 220, 244, 1)",
    "rgba(172, 145, 228, 1)",
    "rgba(236, 137, 214, 1)",
    "rgba(255, 222, 173, 1)", // Navajo White
    "rgba(224, 255, 255, 1)", // Light Cyan
    "rgba(255, 182, 193, 1)", // Light Pink
    "rgba(250, 250, 210, 1)", // Light Goldenrod Yellow
  ];

  //   const colors = [
  //     "rgba(240, 128, 128, 1)",  // Light Coral
  //     "rgba(144, 238, 144, 1)",  // Light Green
  //     "rgba(173, 216, 230, 1)",  // Light Blue
  //     "rgba(221, 160, 221, 1)",  // Plum
  //     "rgba(255, 222, 173, 1)",  // Navajo White
  //     "rgba(224, 255, 255, 1)",  // Light Cyan
  //     "rgba(255, 182, 193, 1)",  // Light Pink
  //     "rgba(250, 250, 210, 1)",  // Light Goldenrod Yellow
  // ];

  const allDatasets = Array.isArray(graphDataNew)
    ? graphDataNew.map((item, index) => ({
        label: item.depo,
        data: item.data1.map((item) => item.amount),
        backgroundColor: colors[index],
        categoryPercentage: activeYearly === 2 ? 0.2 : 0.34,
        borderWidth: 1,
        borderColor: "white",
        borderRadius: {
          topLeft: 6,
          topRight: 6,
          bottomLeft: 6,
          bottomRight: 6,
        },
        borderSkipped: false,
      }))
    : null;

  console.log("allDatasets", allDatasets);

  const chartData = {
    labels: data,
    datasets: location.pathname.includes("centralDashboard")
      ? allDatasets
      : allDatasets,
  };

  const options = {
    type: "bar",
    stacked: true,
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      datalabels: {
        display: false,
      },
      title: {
        display: false,
        text: "Hired Vehicle Report",
      },
      tooltip: {
        displayColors: true,
        yAlign: "bottom",
        backgroundColor: "rgba(254, 235, 230, 1)",
        titleColor: "black",
        bodyColor: "black",
        footerColor: "black",
        bodyFont: {
          size: 14,
          family: "Jost, sans-serif",
        },
        titleFont: {
          size: 15,
          family: "Jost, sans-serif",
        },
      },
      legend: {
        display: true,
        position: "top",
        align: "end",
        labels: {
          boxWidth: 13,
          useBorderRadius: true,
          borderRadius: "6px",
        },
      },
    },
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
    scales: {
      x: {
        stacked: true,
        grid: {
          drawOnChartArea: true,
          display: false,
        },
        border: {
          display: false,
        },
        ticks: {
          font: {
            size: 13,
            weight: "bold",
            family: "Jost",
          },
        },
      },
      y: {
        stacked: true,
        beginAtZero: true,
        grid: {
          drawOnChartArea: true,
        },
        ticks: {
          beginAtZero: true,
        },
        suggestedMin: 0,
        suggestedMax: 10,
        title: {
          display: true,
          text: "Challan Count",
        },
      },
    },
    elements: {
      point: {
        radius: 0,
      },
    },
  };

  return (
    <>
      <div className="graph-header">
        <div className="graph-heading">Challan Generated (Vendor)</div>
        <div className="graph-yearly-filter">
          <div
            className={activeYearly === 1 ? "filter-box active" : "filter-box"}
            onClick={() => handleYearlyFilter(1)}
          >
            Last 7 Days
          </div>
          <div
            className={activeYearly === 2 ? "filter-box active" : "filter-box"}
            onClick={() => handleYearlyFilter(2)}
          >
            Monthly
          </div>
          <div
            className={activeYearly === 3 ? "filter-box active" : "filter-box"}
            onClick={() => handleYearlyFilter(3)}
          >
            Yearly
          </div>
        </div>
      </div>
      <div className="mt-3">
        <Bar data={chartData} options={options} width={600} height={275} />
      </div>
    </>
  );
}

export default ChallanGeneratedGraph;
